import { render, staticRenderFns } from "./PoliticalFormComponent.vue?vue&type=template&id=41bb67b6"
import script from "./PoliticalFormComponent.vue?vue&type=script&lang=js"
export * from "./PoliticalFormComponent.vue?vue&type=script&lang=js"
import style0 from "./PoliticalFormComponent.vue?vue&type=style&index=0&id=41bb67b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports